import { useSyncExternalStore } from 'react'

import { applyPwaUpdate, isPwaUpdateAvailable, subscribePwaUpdate } from '../lib/pwaUpdate'

// A new release came while the page was in use (lib/pwaUpdate.ts). Reloading on our own could drop
// a half-filled form, so the user picks the moment; an unanswered offer is applied anyway the next
// time the app comes back from a long absence.
export default function PwaUpdateBanner() {
  const available = useSyncExternalStore(subscribePwaUpdate, isPwaUpdateAvailable, () => false)
  if (!available) return null

  return (
    <>
      <style>{`
        .pwa-update {
          position: fixed; left: 16px; right: 16px; z-index: 1001;
          top: calc(env(safe-area-inset-top, 0px) + 12px);
          margin: 0 auto; max-width: 480px;
          background: rgba(15, 23, 42, 0.96); color: #e2e8f0;
          border: 1px solid rgba(148, 163, 184, 0.25);
          border-radius: 14px; padding: 10px 10px 10px 16px;
          display: flex; align-items: center; gap: 12px;
          box-shadow: 0 12px 40px rgba(0,0,0,0.35);
          font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif;
        }
        .pwa-update__text { flex: 1; font-size: 13px; line-height: 1.4; }
        .pwa-update__btn {
          flex-shrink: 0; padding: 8px 14px; border: none; border-radius: 10px;
          background: #fff; color: #0f172a; font-size: 13px; font-weight: 600;
          cursor: pointer; font-family: inherit;
        }
      `}</style>
      <div className="pwa-update" role="status">
        <div className="pwa-update__text">Вышла новая версия Лупы</div>
        <button type="button" className="pwa-update__btn" onClick={applyPwaUpdate}>
          Обновить
        </button>
      </div>
    </>
  )
}
